var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYourAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 17C14.1421 17 17.5 13.6421 17.5 9.5C17.5 5.35786 14.1421 2 10 2C5.85786 2 2.5 5.35786 2.5 9.5C2.5 13.6421 5.85786 17 10 17Z",
    stroke: "black",
    strokeWidth: 1.125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5V14M12.25 7.625C12.25 6.59 11.2427 5.75 10 5.75C8.75725 5.75 7.75 6.59 7.75 7.625C7.75 8.66 8.75725 9.5 10 9.5C11.2427 9.5 12.25 10.34 12.25 11.375C12.25 12.41 11.2427 13.25 10 13.25C8.75725 13.25 7.75 12.41 7.75 11.375",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourAccount);
export default __webpack_public_path__ + "static/media/your-account.e95f8a6b6fbd45ee142f2c1c5075894c.svg";
export { ForwardRef as ReactComponent };